var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.51367,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#7A7A7A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 7,
    r: 2,
    transform: "rotate(90 14.5137 7)",
    fill: "#7A7A7A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 13,
    r: 2,
    transform: "rotate(90 14.5137 13)",
    fill: "#7A7A7A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5137,
    cy: 19,
    r: 2,
    transform: "rotate(90 14.5137 19)",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOutline);
export default __webpack_public_path__ + "static/media/menuOutline.6411442a57bbfaaa3773dfae0067c7dd.svg";
export { ForwardRef as ReactComponent };